import React from 'react'
import Navbar from '../components/Navbar'
import ContactUsImg from '../assets/contact-us.png'
import SocialFacebook from '../components/SocialFacebook'
import SocialInstagram from '../components/SocialInstagram'
import ProjectSlider from '../components/ProjectSlider'
import Footer from '../components/Footer'

const ContactView = () => {
  return (
    <>
        <main className='bg-[#FFFAE5]'>
            <Navbar inverse={true} />

            <header className='pb-24'>
                <section className='flex flex-col sm:flex-row gap-8'>
                    <div className='w-full min-h-[420px] md:min-h-[590px] bg-center bg-no-repeat bg-cover' style={{ backgroundImage: `url(${ContactUsImg})` }}></div>
                    <div className='place-self-center w-11/12'>
                        <div className='sm:w-72 lg:w-64 flex flex-col gap-y-3'>
                            <h1 className='uppercase tf-rozha font-medium text-8xl'>Reach Us On</h1>
                            <a  className='text-3xl tf-inter block' href="tel:+2348087414122">+234 808 741 4122</a>
                            <a href="mailto:support@abiyamogboja.com" className='text-3xl block tf-inter'>support@abiyamogboja.com</a>

                            <span className='flex place-items-center gap-x-2 mt-4'>
                                <SocialFacebook />
                                {/* <SocialInstagram /> */}
                            </span>
                        </div>
                    </div>
                </section>

                <section className='mt-20 w-full md:w-7/12 xl:w-10/12 mx-auto'>
                    <ProjectSlider />
                </section>
            </header>
        </main>

        <Footer  />
    </>
  )
}

export default ContactView